import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  useTheme,
  Checkbox,
  Typography,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';

import {
  firstDayofYear,
  getFirstDayOfYear,
  getLastDayOfYear,
  lastDayofYear,
  subYearStrDt,
} from '../../../utils/calcDatetime';
import CommonDatePicker from '../util/CommonDatePicker';

export const ShareSearchBox = ({ isForeCast = false, onAddClick, formik, onSearch, isAllChecked, setIsAllChecked }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [openFilter, setOpenFilter] = useState(false);

  const toggleFilter = () => setOpenFilter(!openFilter);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  const handleChangeThisYear = () => {
    formik.setFieldValue('searchStrtDt', firstDayofYear);
    formik.setFieldValue('searchEndDt', lastDayofYear);
  };

  const handleChangeLastYear = () => {
    const paramDate = subYearStrDt(1);
    formik.setFieldValue('searchStrtDt', getFirstDayOfYear(paramDate));
    formik.setFieldValue('searchEndDt', getLastDayOfYear(paramDate));
  };

  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();
    if (onSearch) {
      onSearch();
    } else {
      formik.handleSubmit();
    }
    if (isMobile) setOpenFilter(false);
  };

    const [localAllChecked, setLocalAllChecked] = useState(isAllChecked);

  useEffect(() => {
    setLocalAllChecked(isAllChecked);
  }, [isAllChecked]);

  const handleChange = (e) => {
    setLocalAllChecked(e.target.checked);
    setIsAllChecked(e.target.checked);
  };

  const renderSearchFields = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      alignItems: 'center',
      justifyContent: { md: 'flex-end' },
      gap: { xs: 2, md: 1 },
      width: '100%',
      height: isMobile ? 'auto' : '50px', 
      transform: { xs: 'none', md: 'translateY(-5.7px)' } 
    }}
  >
<Box sx={{ display: 'flex', alignItems: 'center', mb: '2px', flexShrink: 0 }}>
  <Checkbox 
    size="small" 
    sx={{ p: 0, mr: 0.5 }} 
    checked={localAllChecked} 
    onChange={handleChange} 
  />
  {/* flexDirection: 'column'을 주어 텍스트를 위아래로 배치합니다 */}
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2 }}>
    <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: 'text.secondary' }}>
      전체
    </Typography>
    <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: 'text.secondary' }}>
      부서
    </Typography>
  </Box>
</Box>
    <TextField
      variant="standard"
      select
      name="searchKeyword"
      label="검색키워드"
      value={formik.values.searchKeyword}
      onChange={formik.handleChange}
      sx={{ width: { xs: '100%', md: '14ch' } }}
    >
      <MenuItem value="cstNm">사업명</MenuItem>
      <MenuItem value="vendorCmpNm">매출처명</MenuItem>
      <MenuItem value="crtDptNm">부서</MenuItem>
      <MenuItem value="crtNm">영업담당자</MenuItem>
      <MenuItem value="cstStatus">상태</MenuItem>
    </TextField>

    <TextField
      variant="standard"
      name="searchWords"
      label="검색어"
      value={formik.values.searchWords}
      onChange={formik.handleChange}
      sx={{ width: { xs: '100%', md: '22ch' } }}
    />
    
    {/* 두 달력을 감싸는 부모 Box */}
    <Box sx={{ 
      display: 'flex', 
      gap: 0,                           
      width: { xs: '110%', md: 'auto' }, 
      justifyContent: 'space-between',
      alignItems: 'center', // 수직 중앙 정렬
      
      // 내부 컴포넌트(CommonDatePicker)들의 마진 및 아이콘 구조 조절
      '& > div': {
        mx: { md: 0 }, // 공통 컴포넌트 내부의 기본 mx: 2 마진을 0으로 지워서 강제 결합
        
        // [원상복구] 날짜 글씨 크기는 원래 기본 크기로 복원 (fontSize 삭제)
        '& .MuiInputBase-input': {
          paddingRight: { md: 0 },      
        },
        // 달력 아이콘 버튼 영역 여백 최소화 (글자가 밀려서 가려지는 현상 방지)
        '& .MuiInputAdornment-root': {
          marginLeft: { md: '-4px' },   
        },
        '& .MuiIconButton-root': {
          padding: { md: '4px' },       
          marginRight: { md: '-4px' },  
          '& .MuiSvgIcon-root': {
            fontSize: { md: '1.25rem' }  // 달력 아이콘 크기도 원래 밸런스 유지
          }
        }
      },
      // [수정] 첫 번째 달력과 두 번째 달력 덩어리 자체의 사이 간격 설정
      '& > div:first-of-type': {
        marginRight: { md: '4px' }      // 두 달력 사이를 겹치지 않고 촘촘하게 떼어놓음 (원하는 만큼 변경 가능)
      }
    }}>
      <CommonDatePicker
        label="매출 시작일"
        name="searchStrtDt"
        value={formik.values.searchStrtDt}
        formik={formik}
        onChange={onChangeDate}
        width={isMobile ? '48%' : '14ch'} // [원상복구] 큰 글씨가 짤리지 않도록 원래 너비 규격인 14ch로 복원
      />
      <CommonDatePicker
        label="매출 종료일"
        name="searchEndDt"
        value={formik.values.searchEndDt}
        formik={formik}
        onChange={onChangeDate}
        width={isMobile ? '48%' : '14ch'} // [원상복구] 큰 글씨가 짤리지 않도록 원래 너비 규격인 14ch로 복원
      />
    </Box>
  </Box>
);


  return (
    <Box sx={{ my: { xs: 1, md: 0 } }}>
      {isMobile ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
          <Button
            fullWidth
            variant="outlined"
            color="info"
            startIcon={<FilterListIcon />}
            onClick={toggleFilter}
          >
            검색 필터 설정
          </Button>
        </Box>
      ) : (
        <Box
          component="form"
          onSubmit={handleSearchSubmit}
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'flex-end', 
            gap: 1, 
            width: '100%'
          }}
        >
          {renderSearchFields()}
          
          <Box sx={{ display: 'flex', gap: 1, ml: 1, whiteSpace: 'nowrap', alignItems: 'center' }}>
            <Button 
              variant="outlined" 
              color="info" 
              onClick={handleChangeThisYear} 
              sx={{ px: '10px', minWidth: 'auto' }}
            >
              금년
            </Button>
            <Button 
              variant="outlined" 
              color="info" 
              onClick={handleChangeLastYear} 
              sx={{ px: '10px', minWidth: 'auto' }}
            >
              작년
            </Button>
            <Button 
              type="submit" 
              variant="contained" 
              color="info" 
              startIcon={<SearchIcon />}
            >
              검색
            </Button>
            {isForeCast && (
              <Button variant="contained" color="secondary" onClick={onAddClick}>
                포캐스팅 추가
              </Button>
            )}
          </Box>

        </Box>
      )}

      <Dialog open={openFilter} onClose={toggleFilter} fullWidth maxWidth="xs">
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>상세 검색 필터</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ py: 1 }}>
            {renderSearchFields()}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 3 }}>
              <Button fullWidth variant="outlined" color="info" onClick={handleChangeThisYear}>
                금년 데이터
              </Button>
              <Button fullWidth variant="outlined" color="info" onClick={handleChangeLastYear}>
                작년 데이터
              </Button>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={toggleFilter} sx={{ color: 'text.secondary', flex: 1 }}>
            닫기
          </Button>
          <Button onClick={handleSearchSubmit} variant="contained" color="info" sx={{ flex: 2 }}>
            적용
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
